import { HelpersModule } from "../helpers/helpers";
import { CookieHelper } from "../cookies/cookies";

const helpersModule = new HelpersModule();
const cookiesHelper = new CookieHelper();

let config = {
        ctaSelector: ".js-call-to-action--desktop",
        $ctaHandle : $(".js-call-to-action__handle")
    }

export class CallToActionModule {
    constructor() {
        this.init();
    }

    //toggleVisibility() {
    //    var c = config,
    //        $window = $(window);
    //    var $cta = $(config.ctaSelector);

    //    if (
    //        //SP-840: Stop content being obstructed at certain resolutions 
    //        (($window.height() < 1100 && $window.width() < 1550 && $window.width() > 1150 || $window.width() < 1250) && (sessionStorage.getItem('isExistingSpireSession') == null || cookiesHelper.readCookie('ctaClosed') != 0))
    //        || cookiesHelper.readCookie('ctaClosed') && cookiesHelper.readCookie('ctaClosed') != 0) {
    //        $cta.removeClass("is-on");
    //    } else {
    //        $cta.addClass("is-on");
    //    }
    //};

    init() {
        var that = this;
        var c = config;

        if (sessionStorage.getItem('isExistingSpireSession') == null) {
            cookiesHelper.writeCookie('ctaClosed', 0, 10);
            try {
                sessionStorage.setItem('isExistingSpireSession', 1);
            } catch (e) {
                // console.log(e);
            }
        }

        var $cta = $(config.ctaSelector);

        //if ($("body").find("section").hasClass("enquiry-form")) {
        //    $cta.removeClass("is-on");
        //    cookiesHelper.writeCookie('ctaClosed', 1, 10);
        //} else {
        //    $cta.addClass("is-on");
        //    cookiesHelper.writeCookie('ctaClosed', 0, 10);
        //}

        //that.toggleVisibility();

        $cta.removeClass("call-to-action--desktop--initial-hide");

        $(".js-call-to-action__handle").on("click", function (e) {
            e.preventDefault();
            var $cta = $(config.ctaSelector);

            if ($cta.hasClass("is-on") || ($("body").hasClass("enquiry-form"))) {
                $cta.removeClass("is-on");
                //cookiesHelper.writeCookie('ctaClosed', 1, 10);
            } else {
                $cta.addClass("is-on");
                //cookiesHelper.writeCookie('ctaClosed', 0, 10);
            }
        });

        //var toggleCtaVisibility = helpersModule.debounce(function (element) {
        //    that.toggleVisibility();
        //}, 250);

        //window.addEventListener('resize', toggleCtaVisibility);
    }

}


